<script setup lang="ts">
import { findColorValue } from '@/utils/style'
import { ratingIconConstants } from '@/constants/global/ratingIcon'

const { RATING_ICONS } = ratingIconConstants
const props = defineProps<{
  ratingAvg: number
}>()

const ratingIcon = RATING_ICONS[Math.floor(props.ratingAvg) as keyof typeof RATING_ICONS]
</script>

<template>
  <div class="rating-icon">
    <i :class="'rating-icon-' + ratingIcon.key"
      ><span class="rating-icon-bg"></span><span class="rating-icon-item"></span>
    </i>
    <p class="rating-icon-text">{{ ratingIcon.name }}</p>
  </div>
</template>

<style scoped lang="scss">
.rating-icon {
  display: flex;
  align-items: center;
  line-height: 1;
  i {
    font-size: 32px;
    font-family: 'icomoon';
    font-style: normal;
  }
  .rating-icon-bg {
    font-family: 'icomoon';
  }
  .rating-icon-item {
    margin-left: -32px;
    font-family: 'icomoon';
  }
  .rating-icon-text {
    margin-left: 10px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: bold;
  }
  .rating-icon-very-fine {
    .rating-icon-bg {
      &::before {
        content: '\e91c';
        color: v-bind('findColorValue("yellow")');
      }
    }
    .rating-icon-item {
      &::before {
        content: '\e91d';
        color: v-bind('findColorValue("black")');
      }
    }
  }
  .rating-icon-fine {
    .rating-icon-bg {
      &::before {
        content: '\e91e';
        color: v-bind('findColorValue("yellow")');
      }
    }
    .rating-icon-item {
      &::before {
        content: '\e91f';
        color: v-bind('findColorValue("black")');
      }
    }
  }
  .rating-icon-neutral {
    .rating-icon-bg {
      &::before {
        content: '\e920';
        color: v-bind('findColorValue("light-cream")');
      }
    }
    .rating-icon-item {
      &::before {
        content: '\e921';
        color: v-bind('findColorValue("black")');
      }
    }
  }
  .rating-icon-sad {
    .rating-icon-bg {
      &::before {
        content: '\e922';
        color: v-bind('findColorValue("light-gray")');
      }
    }
    .rating-icon-item {
      &::before {
        content: '\e923';
        color: v-bind('findColorValue("black")');
      }
    }
  }
  .rating-icon-very-sad {
    .rating-icon-bg {
      &::before {
        content: '\e925';
        color: v-bind('findColorValue("light-gray")');
      }
    }
    .rating-icon-item {
      &::before {
        content: '\e926';
        color: v-bind('findColorValue("black")');
      }
    }
  }
}
</style>
